import React from "react";
import { Box, Avatar } from "@material-ui/core";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  CustomBadge,
  SocialLinks,
  LeadTypeBadges,
  ProgressBar,
  CustomIconButton,
  CustomCopyToClipboard,
} from "../../../Components";
import { getDownloadableLink, truncateString } from "../../../Helper";
import { ArrowUpRight } from "../../../assets/icons";

import useStyles from "./styles";

const ContactName = ({ item }) => {
  const { isDarkMode } = useSelector((state) => state.theme);
  const classes = useStyles({ isDarkMode });
  const history = useHistory();

  const handleClick = (item) => {
    if (history) {
      history.push(
        `/home/Contacts-CRM/contact-profile-overview?formType=${
          item?.row?.contact_type_id
        }&id=${item?.row?.contactId || item?.row?.id}`
      );
    }
  };

  const getFullName = () => {
    if (item?.row?.first_name) {
      return `${item?.row?.first_name} ${
        item?.row?.last_name ? item?.row?.last_name : "N/A"
      }`;
    }
    return item?.row?.company_name || "N/A";
  };

  const displayName = getFullName();
  const truncatedName =
    displayName.length >= 18 ? truncateString(displayName, 18) : displayName;

  return (
    <Box className={classes.container}>
      <Box>
        {getDownloadableLink(item?.row?.imagePath) && (
          <Avatar
            className={
              item?.row?.imagePath ? classes.avatar : classes.defaultAvatar
            }
            src={
              item?.row?.imagePath
                ? getDownloadableLink(item?.row?.imagePath)
                : item?.row?.contact_type_id === 2
                ? "/images/contacts/CorporateAvatar.svg"
                : item?.row?.["gender.lookupItemName"] === "Male"
                ? "/images/contacts/MaleAvatar.svg"
                : "/images/contacts/FemaleAvatar.svg"
            }
          />
        )}
      </Box>

      <Box className={classes.detailsColumn}>
        <Box className={classes.nameRow} onClick={() => handleClick(item)}>
          <span className={classes.nameText}>{truncatedName}</span>
          <CustomIconButton
            variant="text"
            size="xs"
            boxShadow="none"
            color="secondary"
          >
            <ArrowUpRight
              width="20"
              height="20"
              fill={!isDarkMode ? "#344054" : "#CECFD2"}
            />
          </CustomIconButton>
        </Box>
        <Box className={classes.socialLinksBox}>
          <SocialLinks activeItem={item?.row} gap={6} />
        </Box>
      </Box>
    </Box>
  );
};

export const newContactsTableHeaderData = (isDarkMode = false) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 242,
    headerName: "Contact name",
    field: "fullName",
    isHiddenFilter: false,
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "fullName",
    isDefaultFilterColumn: true,
    fieldKey: "fullName",
    formFieldTitle: "fullName",
    disableColumnMenu: true,
    searchKey: "fullName",
    renderCell: (item) => {
      return <ContactName item={item} />;
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 160,
    headerName: "Contact Type",
    field: "contactTypeStr",
    filterable: true,
    sortable: true,
    fieldType: "text",
    isDefaultFilterColumn: true,
    displayPath: "contactTypeStr",
    disableColumnMenu: true,
    fieldKey: "contactTypeStr",
    formFieldTitle: "Contact Type",
    renderCell: (item) => {
      return (
        <span>
          {item?.row?.contact_type_id === 2 ? "Corporate" : "Individual"}
        </span>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 130,
    headerName: "Class",
    field: "contact_class.lookupItemName",
    fieldType: "text",
    sortable: true,
    filterable: true,
    displayPath: "contact_class.lookupItemName",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    fieldKey: "contact_class.lookupItemName",
    formFieldTitle: "Class",
    renderCell: (item) => {
      return item?.row?.["contact_class.lookupItemName"] === "VIP" ||
        item?.row?.["company_class.lookupItemName"] === "VIP" ? (
        <CustomBadge
          Style={{
            padding: "0 2px",
            borderRadius: "2px",
            lineHeight: "20px",
          }}
          label={"VIP"}
          BackgroundColor={!isDarkMode ? "#B2A186" : "#635235"}
          BorderColor={!isDarkMode ? "#B2A186" : "#635235"}
          Color={"#FFF"}
        />
      ) : item?.row?.["contact_class.lookupItemName"] === "VVIP" ||
        item?.row?.["company_class.lookupItemName"] === "VVIP" ? (
        <CustomBadge
          Style={{
            padding: "0 2px",
            borderRadius: "2px",
            lineHeight: "20px",
          }}
          label={"VVIP"}
          BackgroundColor={!isDarkMode ? "#7F6944" : "#A38F6F"}
          BorderColor={!isDarkMode ? "#7F6944" : "#A38F6F"}
          Color={"#FFF"}
        />
      ) : (
        <span>Normal</span>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    headerName: "Leads",
    width: 240,
    field: "leadTypes",
    fieldKey: "leadTypes",
    fieldType: "text",
    disableColumnMenu: true,
    displayPath: "leadTypes",
    sortable: true,
    filterable: true,
    isDefaultFilterColumn: true,
    formFieldTitle: "Leads",
    renderCell: (item) => {
      return item?.row?.leadTypes ? (
        <LeadTypeBadges
          leadTypesList={item?.row?.leadTypes}
          translateText={false}
        />
      ) : (
        "N/A"
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 161,
    headerName: "Nationality",
    field: "nationality.lookupItemName",
    fieldType: "text",
    fieldKey: "nationality.lookupItemName",
    sortable: true,
    displayPath: "nationality.lookupItemName",
    filterable: true,
    disableColumnMenu: true,
    isDefaultFilterColumn: true,
    formFieldTitle: "Nationality",
    renderCell: (item) => {
      return (
        <label style={{ fontWeight: 500 }}>
          {item?.row?.["nationality.lookupItemName"] ||
            item?.row?.["company_nationality.lookupItemName"] ||
            "N/A"}
        </label>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 190,
    headerName: "Creation Date",
    field: "createdOn",
    isHiddenFilter: false,
    filterable: true,
    disableColumnMenu: true,
    fieldType: "datePicker",
    displayPath: "createdOn",
    isDate: true,
    sortable: true,
    isDefaultFilterColumn: true,
    fieldKey: "createdOn",
    formFieldTitle: "Creation Date",
    renderCell: (item) => {
      return (
        <Box style={{ display: "flex", flexDirection: "column" }}>
          {item?.row?.createdOn && (
            <label style={{ lineHeight: "20px", fontWeight: 500 }}>
              {moment(item.row.createdOn).format("DD MMM YYYY")}
            </label>
          )}
          {item?.row?.createdBy && (
            <span
              style={{
                lineHeight: "20px",
                fontWeight: 400,
                color: !isDarkMode ? "#475467" : "#94969C",
              }}
            >
              {item.row.createdBy}
            </span>
          )}
        </Box>
      );
    },
  },
  {
    id: 7,
    formFieldId: 7,
    minWidth: 190,
    headerName: "Updated Date",
    field: "updateOn",
    displayPath: "updateOn",
    isHiddenFilter: false,
    filterable: true,
    fieldType: "datePicker",
    disableColumnMenu: true,
    fieldKey: "updateOn",
    isDate: true,
    sortable: true,
    isDefaultFilterColumn: true,
    formFieldTitle: "Updated Date",
    renderCell: (item) => {
      return (
        <Box style={{ display: "flex", flexDirection: "column" }}>
          {item?.row?.updateOn && (
            <label style={{ lineHeight: "20px", fontWeight: 500 }}>
              {moment(item.row.updateOn).format("DD MMM YYYY")}
            </label>
          )}
          {item?.row?.updatedBy && (
            <span
              style={{
                lineHeight: "20px",
                fontWeight: 400,
                color: !isDarkMode ? "#475467" : "#94969C",
              }}
            >
              {item.row.updatedBy}
            </span>
          )}
        </Box>
      );
    },
  },
  {
    id: 8,
    formFieldId: 8,
    minWidth: 190,
    headerName: "Progress",
    field: "data_completed",
    displayPath: "data_completed",
    fieldKey: "data_completed",
    filterable: false,
    textInputType: "number",
    disableColumnMenu: true,
    textInputMax: 100,
    textInputMin: 0,
    isHiddenFilter: true,
    fieldType: "number",
    isNumber: true,
    sortable: false,
    isDefaultFilterColumn: true,
    formFieldTitle: "Progress",
    renderCell: (item) => {
      return (
        <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Box style={{ width: "100px", display: "flex" }}>
            <ProgressBar staticProgress={item?.row?.progress || 0} />
          </Box>
          <label style={{ fontSize: "14px", fontWeight: 500 }}>
            {item?.row?.progressWithPercentage}
          </label>
        </Box>
      );
    },
  },
  {
    minWidth: 170,
    id: 9,
    formFieldId: 9,
    headerName: "isBulkUpload",
    field: "isBulkUpload",
    displayPath: "isBulkUpload",
    fieldKey: "isBulkUpload",
    isHiddenFilter: false,
    disableColumnMenu: true,
    filterable: true,
    sortable: true,
    data: { enum: ["Yes", "No"] },
    fieldType: "select",
    isDefaultFilterColumn: true,
    formFieldTitle: "isBulkUpload",
    renderCell: (item) => <div>{!!item?.row?.isBulkUpload ? "Yes" : "No"}</div>,
  },
  {
    id: 10,
    formFieldId: 10,
    minWidth: 250,
    headerName: "Phone",
    field: "mobile.phone",
    isHiddenFilter: false,
    fieldKey: "mobile.phone",
    fieldType: "text",
    disableColumnMenu: true,
    filterable: true,
    displayPath: "mobile.phone",
    sortable: true,
    isDefaultFilterColumn: true,
    formFieldTitle: "Phone",
    renderCell: (item) => {
      const counter =
        item?.row?.["other_contact_mobile_no.others"] ||
        item?.row?.["landline_number.others"];

      return (
        <span>
          {item?.row?.["mobile.phone"] ||
            item?.row?.["landline_number.phone"] ||
            "N/A"}
          {(item?.row?.["others.phone"]?.length > 0 ||
            item?.row?.["landline_number.others"]?.length > 0) && (
            <CustomBadge
              Style={{
                padding: "0 4px",
                height: "18px",
                marginLeft: "5px",
              }}
              label={`+${counter?.length}`}
              SizeVariant={"small"}
              BackgroundColor={!isDarkMode ? "#F9FAFB" : "#161B26"}
              BorderColor={!isDarkMode ? "#EAECF0" : "#333741"}
              Color={!isDarkMode ? "#344054" : "#CECFD2"}
            />
          )}
        </span>
      );
    },
  },
  {
    minWidth: 240,
    id: 11,
    formFieldId: 11,
    headerName: "Email",
    field: "email_address.email",
    isHiddenFilter: false,
    fieldKey: "email_address.email",
    fieldType: "text",
    sortable: true,
    displayPath: "email_address.email",
    disableColumnMenu: true,
    filterable: true,
    isDefaultFilterColumn: true,
    formFieldTitle: "Email",
    renderCell: (item) => {
      const counter =
        item?.row?.["email_address.others"] ||
        item?.row?.["general_email.others"];

      return (
        <span>
          {((item?.row?.["email_address.email"] ||
            item?.row?.["general_email.email"]) &&
            truncateString(
              item?.row?.["email_address.email"] ||
                item?.row?.["general_email.email"]
            )) ||
            "N/A"}
          {(item?.row?.["email_address.others"]?.length > 0 ||
            item?.row?.["general_email?others"]?.length > 0) && (
            <CustomBadge
              Style={{
                padding: "0 4px",
                height: "18px",
                marginLeft: "5px",
              }}
              label={`+${counter?.length}`}
              SizeVariant={"small"}
              BackgroundColor={!isDarkMode ? "#F9FAFB" : "#161B26"}
              BorderColor={!isDarkMode ? "#EAECF0" : "#333741"}
              Color={!isDarkMode ? "#344054" : "#CECFD2"}
            />
          )}
        </span>
      );
    },
  },
  {
    disableColumnMenu: true,
    displayPath: "all",
    field: "all",
    fieldKey: "all",
    fieldType: "text",
    filterable: true,
    formFieldId: 12,
    formFieldTitle: "all",
    headerName: "All",
    headerName: "All",
    id: 12,
    isDate: false,
    isDefaultFilterColumn: false,
    isHiddenFilter: false,
    isNumber: false,
    isSortable: true,
    key: "all",
    minWidth: 190,
    searchKey: "all",
    searchableKey: "all",
    sortable: true,
    title: "All",
  },
  {
    disableColumnMenu: true,
    displayPath: "Ids",
    field: "Ids",
    fieldKey: "Ids",
    fieldType: "text",
    filterable: true,
    formFieldId: 13,
    formFieldTitle: "Ids",
    headerName: "Contact Id",
    headerName: "Contact Id",
    id: 13,
    isDate: false,
    isDefaultFilterColumn: false,
    isHiddenFilter: false,
    isNumber: false,
    isSortable: true,
    key: "Ids",
    minWidth: 190,
    searchKey: "Ids",
    searchableKey: "Ids",
    sortable: true,
    title: "Contact Id",
    renderCell: (item) => {
      return (
        <CustomCopyToClipboard
          data={item?.row?.id} // copy
          childrenData={"#" + item?.row?.Ids} // render
          copyDoneShowTime={1000}
          fontSize="14px"
        />
      );
    },
  },
  {
    disableColumnMenu: true,
    displayPath: "lead_id",
    field: "lead_id",
    fieldKey: "lead_id",
    fieldType: "text",
    filterable: true,
    formFieldId: 14,
    formFieldTitle: "lead_id",
    headerName: "Lead Id",
    headerName: "Lead Id",
    id: 14,
    isDate: false,
    isDefaultFilterColumn: false,
    isHiddenFilter: false,
    isNumber: false,
    isSortable: true,
    key: "lead_id",
    minWidth: 190,
    searchKey: "lead_id",
    searchableKey: "lead_id",
    sortable: true,
    title: "Lead Id",
  },
  {
    disableColumnMenu: true,
    displayPath: "createdBy",
    field: "createdBy",
    fieldKey: "createdBy",
    fieldType: "text",
    filterable: true,
    formFieldId: 15,
    formFieldTitle: "createdBy",
    headerName: "Created By",
    headerName: "Created By",
    id: 15,
    isDate: false,
    isDefaultFilterColumn: false,
    isHiddenFilter: false,
    isNumber: false,
    isSortable: true,
    key: "createdBy",
    minWidth: 190,
    searchKey: "createdBy",
    searchableKey: "createdBy",
    sortable: true,
    title: "Created By",
  },
  {
    disableColumnMenu: true,
    displayPath: "updatedBy",
    field: "updatedBy",
    fieldKey: "updatedBy",
    fieldType: "text",
    filterable: true,
    formFieldId: 16,
    formFieldTitle: "updatedBy",
    headerName: "Updated By",
    headerName: "Updated By",
    id: 16,
    isDate: false,
    isDefaultFilterColumn: false,
    isHiddenFilter: false,
    isNumber: false,
    isSortable: true,
    key: "updatedBy",
    minWidth: 190,
    searchKey: "updatedBy",
    searchableKey: "updatedBy",
    sortable: true,
    title: "Updated By",
  },
];
